import React, { createContext, ReactNode, useContext } from "react";
import useQuestionManager, { UseQuestionManagerReturnType } from "../hooks/useQuestionManager";

const QuestionContext = createContext<UseQuestionManagerReturnType | null>(null);

interface QuestionProviderProps {
  children: ReactNode;
  initialValue?: UseQuestionManagerReturnType;
}

const QuestionProvider: React.FC<QuestionProviderProps> = ({ children, initialValue }) => {
  const questionManager = useQuestionManager();

  return (
    <QuestionContext.Provider value={initialValue || questionManager}>
      {children}
    </QuestionContext.Provider>
  );
};

export { QuestionContext, QuestionProvider };

export const useQuestion = () => {
  const context = useContext(QuestionContext);
  if (!context) {
    throw new Error("useQuestion must be used within a QuestionProvider");
  }
  return context;
};
